export const SITE_TITLE = 'POTENTIAL CLOUD'
